import { render, staticRenderFns } from "./MFormRadio.vue?vue&type=template&id=06e20084&"
import script from "./MFormRadio.vue?vue&type=script&lang=js&"
export * from "./MFormRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports